<app-modal
  [(open)]="open"
  [title]="mode === 'add' ? 'Create Layout' : 'Edit Layout'"
  [subtitle]="'Group: ' + group.groupId"
  size="medium"
  (closed)="onClose()"
>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
    <app-form-field
      [error]="form.get('templateId')?.invalid && form.get('templateId')?.touched ? 'Layout ID is required.' : null"
    >
      <app-text-input
        type="text"
        label="Layout ID"
        placeholder="e.g. layout-001"
        formControlName="templateId"
        [invalid]="!!(form.get('templateId')?.invalid && form.get('templateId')?.touched)"
      />
    </app-form-field>

    <app-number-input
      label="Order in Group"
      placeholder="e.g. 1"
      [min]="0"
      formControlName="groupOrderNum"
    />

    <app-select
      label="Activation Event"
      placeholder="— None —"
      [clearable]="true"
      [options]="activationEvents"
      formControlName="activationEvent"
    />

    <app-form-field help="Comma-separated button codes">
      <app-text-input
        type="text"
        label="Activation Buttons"
        placeholder="e.g. A,B"
        formControlName="activationButtons"
      />
    </app-form-field>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <app-number-input
        label="Offline Delay (s)"
        placeholder="e.g. 30"
        [min]="0"
        formControlName="activationOfflineDelay"
      />
      <app-number-input
        label="Slideshow Duration (ms)"
        placeholder="e.g. 10000"
        [min]="0"
        formControlName="slideshowDuration"
      />
    </div>
  </form>

  <ng-template modalFooter>
    <div class="flex flex-1 items-center justify-end gap-2">
      <button
        type="button"
        (click)="onClose()"
        class="rounded-control border border-hairline bg-card px-4 py-2 text-[13px] font-semibold text-ink-1 hover:bg-sunken"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="onSubmit()"
        [disabled]="form.invalid"
        class="rounded-control bg-action px-4 py-2 text-[13px] font-semibold text-action-text disabled:opacity-40 hover:brightness-90"
      >
        {{ mode === 'add' ? 'Create' : 'Save' }}
      </button>
    </div>
  </ng-template>
</app-modal>
